/**
 * ARCHIVO GENERADO por scripts/generate-env.mjs a partir de .env.development.
 * No lo edites a mano: cambia el .env correspondiente y corre `npm run config`.
 */
export const environment = {
  production: false,
  appName: "Refac Admin Panel",
  apiUrl: "https://dev-api.refac.mx/api/v1",
  tokenKey: "rap_access_token",
  refreshTokenKey: "rap_refresh_token",
  defaultPageSize: 10,
};
